import React, { Component } from 'react';
import Button from '../Button.js';

export default (props) => (
  <div id="payment-failed" className="payment-feedback collapsible collapsible--inverse">
    <span className="line"></span>
    <div className="collapsible__panel">
      <div className="collapsible__content">

        <div className="collapsible__body">
          <h2>Error!</h2>
          <p>{ props.message }</p>
          <p>Du kan altid kontakte os <a href="mailto:contact@risika.com">contact@risika.com</a>.</p>
        </div>

        <div className="collapsible__controls">
          <button className="btn btn-outlined btn-inverse" onClick={ props.onClose }>
            Ny søgning
          </button>
        </div>
      </div>
    </div>
  </div>
);
